module.exports = __webpack_public_path__ + "img/black-download-icon.824b9a94.svg";